import React, { useState, createContext } from 'react'

export const AppStateContext = createContext(null)

const Layout = ({ children, props }) => {
  const [appState, setAppState] = useState({
    lang: props.locales.edges[0].node.language
  })

  return <AppStateContext.Provider value={[appState, setAppState]}><main className="font-rubik">{children}</main></AppStateContext.Provider>
}

export default Layout
